import { Container } from '../components/Container'

const features = [
  {
    name: 'Learning system',
    summary: 'Every reviewed text helps improve the model.',
    description:
      'Digitalfalse learns from real-world examples. Known-source submissions help the system better understand the difference between human and AI-authored writing.',
    icon: function LearningIcon() {
      return (
        <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none">
          <path d="M12 3 3 8l9 5 9-5-9-5Z" stroke="currentColor" strokeWidth="1.8" />
          <path d="M6 10.5V15c0 2 2.7 3.5 6 3.5s6-1.5 6-3.5v-4.5" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      )
    },
  },
  {
    name: 'Clear indicators',
    summary: 'Understand why a text raises suspicion.',
    description:
      'Instead of a black-box verdict, Digitalfalse highlights signals and patterns that may suggest machine-generated writing.',
    icon: function IndicatorsIcon() {
      return (
        <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none">
          <path d="M5 6h14M5 12h9M5 18h6" stroke="currentColor" strokeWidth="1.8" />
          <path d="m16 16 2 2 4-5" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      )
    },
  },
  {
    name: 'Free (for now)',
    summary: 'Use the detector while the system improves.',
    description:
      'Digitalfalse is currently in a learning phase. As more classified examples are processed, detection quality will improve over time.',
    icon: function FreeIcon() {
      return (
        <svg viewBox="0 0 24 24" className="h-7 w-7" fill="none">
          <path d="M20 12v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7" stroke="currentColor" strokeWidth="1.8" />
          <path d="M3 8h18v4H3V8Z" stroke="currentColor" strokeWidth="1.8" />
          <path d="M12 21V8" stroke="currentColor" strokeWidth="1.8" />
        </svg>
      )
    },
  },
]

function FeatureCard({ feature }) {
  return (
    <div className="rounded-3xl bg-white/10 p-6 ring-1 ring-white/15 backdrop-blur transition hover:bg-white/15">
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-blue-500 text-white">
        <feature.icon />
      </div>

      <h3 className="mt-6 text-xl font-semibold text-slate-600">
        {feature.name}
      </h3>

      <p className="mt-2 text-base text-slate-600">
        {feature.summary}
      </p>

      <p className="mt-3 text-sm text-slate-600">
        {feature.description}
      </p>
    </div>
  )
}

export function SecondaryFeatures() {
  return (
    <section
      id="features"
      className="relative overflow-hidden bg-slate-950 py-24 sm:py-32"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(37,99,235,0.3),transparent_40%)]" />

      <Container className="relative">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-4xl font-semibold text-blue-400 sm:text-5xl">
            Smarter signals for AI detection
          </h2>

          <p className="mt-6 text-lg text-slate-300">
            Digitalfalse analyses millions of texts to surface patterns that help identify AI-generated writing.
          </p>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-3">
          {features.map((feature) => (
            <FeatureCard key={feature.name} feature={feature} />
          ))}
        </div>

        <div className="mt-16 text-center text-white">
          <p className="text-4xl font-semibold">4,000,000+</p>
          <p className="mt-2 text-sm text-slate-400">
            texts currently indexed in Digitalfalse
          </p>
        </div>
      </Container>
    </section>
  )
}